export default function validation(response, messages) {
  if (!response?.data?.error?.validationErrors) return;
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message !== null) {
      if (message.indexOf('MATERIEL_DIFFERENT_CLIENT_ID') !== -1) {
        messages.push({
          message: 'detailDispositif.popupDeplacerMateriel.errors.materielDifferentClient',
        });
      }
    }
  });
}
